export function validateCountry(country, arrayCountry = []) {
  if (arrayCountry.length === 0) {
    return false;
  }
  return arrayCountry.includes(country);
}
